import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { ethers } from "ethers";
import { useEffect, useState } from "react";
import governorAbi from "../Populus/Populus.json";
const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
function Proposal() {
  let params = useParams();
  const contractAddress = "0x93681566B63659db5dacB9FdC3c8934Ae8fcDEcB";

  const provider = new ethers.providers.AlchemyProvider(
    "matic",
    "_8TZHcd_cqmy0KNW3bQuBEDWhnnRIzg5"
  );
  const [proposal, setProposal] = useState();
  useEffect(() => {
    async function getProposals() {
      console.log("provider", provider);

      const contract = new ethers.Contract(
        contractAddress,
        governorAbi,
        provider
      );
      console.log("contract", contract);

      const filter = contract.filters.ProposalCreated();
      const iface = new ethers.utils.Interface(governorAbi);
      const logs = await contract.queryFilter(filter);
      console.log("logs", logs);

      const parsedLogs = structuredClone(
        logs.map((log) => iface.parseLog(log))
      );
      for (var i = 0; i < parsedLogs.length; i++) {
        console.log("args", parsedLogs[i].args);
        var currentBlock = await parseInt(
          parsedLogs[i].args.startBlock._hex,
          16
        );
        console.log("currentBlock", currentBlock);
        parsedLogs[i].args.startTime = await getTime(currentBlock);
      }
      console.log("parsedLogs", parsedLogs);
      setProposal(parsedLogs[Number(params.proposalId )]);
    }
    getProposals();
    // eslint-disable-next-line
  }, []);

  function formatTime(timestamp) {
    var d = new Date(timestamp);
    var time =
      d.getDate() +
      " " +
      MONTHS[d.getMonth()] +
      " " +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();
    return time;
  }

  const getTime = async (blockNumber) => {
    console.log("blocknum", blockNumber);
    const timestamp = await provider.getBlock(blockNumber);
    console.log("timestamp", timestamp.timestamp);
    const returnVal = await formatTime(timestamp.timestamp * 1000);
    return returnVal;
  };

  return (
    <div className="widgetStyling">
      <Link to="/">Back</Link>
      <div className="governanceMain">
      <b>Title:</b> {proposal?.args?.description.split("~~ENDTITLE~~")[0]}
        <p className="noMargin">Proposal {params.proposalId}</p>
      </div>
    </div>
  );
}

export default Proposal;
